<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" v-loading="loading" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="生产日期" prop="productionDate">
              <el-date-picker v-model="formData.productionDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择生产日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productId">
              <el-select v-model="formData.productId" filterable clearable placeholder="请选择产品名称"
                @change="handleProductChange">
                <el-option v-for="item of productList" :key="item.productId" :label="item.productName"
                  :value="item.productId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品规格">
              <el-input v-model="productSpecName" disabled placeholder="选择产品后自动显示" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料名称" prop="rawMaterialSpecId">
              <el-select v-model="formData.rawMaterialSpecId" filterable clearable placeholder="请选择原料名称"
                @change="validateMaterials">
                <el-option v-for="item of specList" :key="item.specId" :label="item.specName"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料号" prop="materialNumber">
              <el-input v-model.trim="formData.materialNumber" placeholder="请输入物料号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料生产日期" prop="rawMaterialProductionDate">
              <el-date-picker v-model="formData.rawMaterialProductionDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择原料生产日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料供应商" prop="rawMaterialSupplierId">
              <el-select v-model="formData.rawMaterialSupplierId" filterable clearable placeholder="请选择原料供应商">
                <el-option v-for="item of supplierList" :key="item.materialsId" :label="item.materialsName"
                  :value="item.materialsId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="罐号" prop="tankNumber">
              <el-input v-model.trim="formData.tankNumber" placeholder="请输入罐号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="辅料名称" prop="auxiliaryMaterialSpecId">
              <el-select v-model="formData.auxiliaryMaterialSpecId" filterable clearable placeholder="请选择辅料名称"
                @change="validateMaterials">
                <el-option v-for="item of specList" :key="item.specId" :label="item.specName"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="辅料生产日期" prop="auxiliaryMaterialDate">
              <el-date-picker v-model="formData.auxiliaryMaterialDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择辅料生产日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="辅料供应商" prop="auxiliarySupplierId">
              <el-select v-model="formData.auxiliarySupplierId" filterable clearable placeholder="请选择辅料供应商">
                <el-option v-for="item of supplierList" :key="item.materialsId" :label="item.materialsName"
                  :value="item.materialsId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投料数量" prop="quantity">
              <el-input v-model.trim="formData.quantity" placeholder="请输入投料数量" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submitting" :disabled="loading || loadFailed" @click="submit" class="global-button">保存</el-button>
          <el-button v-if="loadFailed" @click="loadData" class="global-button">重新加载</el-button>
          <el-button :disabled="submitting" @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'FeedingRecordAdd',
  data() {
    const validateQuantity = (rule, value, callback) => {
      if (!/^\d+(\.\d+)?$/.test(value) || !Number.isFinite(Number(value)) || Number(value) <= 0) {
        callback(new Error('投料数量必须为大于0的数字'))
      } else {
        callback()
      }
    }
    const validateMaterial = (rule, value, callback) => {
      if (!this.formData.rawMaterialSpecId && !this.formData.auxiliaryMaterialSpecId) {
        callback(new Error('原料名称和辅料名称至少选择一项'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      loadFailed: false,
      submitting: false,
      productList: [],
      specList: [],
      supplierList: [],
      productSpecName: '',
      formData: {
        feedingId: '', // 投料记录ID
        productionDate: '', // 生产日期
        productId: '', // 产品名称
        rawMaterialSpecId: '', // 原料名称
        materialNumber: '', // 物料号
        rawMaterialProductionDate: '', // 原料生产日期
        rawMaterialSupplierId: '', // 原料供应商
        tankNumber: '', // 罐号
        auxiliaryMaterialSpecId: '', // 辅料名称
        auxiliaryMaterialDate: '', // 辅料生产日期
        auxiliarySupplierId: '', // 辅料供应商
        quantity: '' // 投料数量
      },
      rules: {
        productionDate: [{ required: true, message: '请选择生产日期', trigger: 'change' }],
        productId: [{ required: true, message: '请选择产品名称', trigger: 'change' }],
        rawMaterialSpecId: [{ validator: validateMaterial, trigger: 'change' }],
        auxiliaryMaterialSpecId: [{ validator: validateMaterial, trigger: 'change' }],
        quantity: [{ required: true, validator: validateQuantity, trigger: 'blur' }]
      }
    }
  },
  computed: {
    feedingId() {
      return this.$route.query.feedingId
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.loadFailed = false
      const requests = [this.loadProductList(), this.loadSpecList(), this.loadSupplierList()]
      if (this.feedingId) {
        requests.push(this.loadDetails())
      }
      return Promise.all(requests).catch(() => {
        this.loadFailed = true
      }).finally(() => {
        this.loading = false
      })
    },
    loadProductList() {
      return this.$axios.get(this.$apis.prodManage.selectScProductByPage).then(res => {
        this.productList = res.list
      })
    },
    loadSpecList() {
      return this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList).then(res => {
        this.specList = res.list
      })
    },
    loadSupplierList() {
      return this.$axios.get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByList).then(res => {
        this.supplierList = res.list
      })
    },
    handleProductChange(productId) {
      const product = this.productList.find(item => item.productId === productId)
      this.productSpecName = product ? product.specName : ''
    },
    validateMaterials() {
      this.$refs.formData.validateField(['rawMaterialSpecId', 'auxiliaryMaterialSpecId'])
    },
    loadDetails() {
      return this.$axios.get(this.$apis.prodManage.selectScFeedingRecordById, {
        params: { feedingId: this.feedingId }
      }).then(res => {
        Object.keys(this.formData).forEach(key => {
          this.formData[key] = res[key] == null ? '' : res[key]
        })
        this.formData.productionDate = res.productionDate ? dayjs(res.productionDate).format('YYYY-MM-DD') : ''
        this.formData.rawMaterialProductionDate = res.rawMaterialProductionDate ? dayjs(res.rawMaterialProductionDate).format('YYYY-MM-DD') : ''
        this.formData.auxiliaryMaterialDate = res.auxiliaryMaterialDate ? dayjs(res.auxiliaryMaterialDate).format('YYYY-MM-DD') : ''
        this.productSpecName = res.productSpecName || ''
      })
    },
    submit() {
      if (this.loading || this.loadFailed || this.submitting) {
        return
      }
      this.$refs.formData.validate(valid => {
        if (!valid || this.submitting) {
          return
        }
        this.submitting = true
        let url = this.$apis.prodManage.insertScFeedingRecord
        if (this.feedingId) {
          url = this.$apis.prodManage.updateScFeedingRecord
        }
        this.$axios.post(url, {
          ...this.formData,
          feedingId: this.feedingId,
          rawMaterialProductionDate: this.formData.rawMaterialProductionDate || null,
          auxiliaryMaterialDate: this.formData.auxiliaryMaterialDate || null
        }).then(() => {
          this.$router.back()
        }).catch(() => {
          // 请求错误由全局拦截器提示，保留表单供修改后重试。
        }).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select,
.el-input,
.el-date-editor,
.el-textarea {
  width: 95%;
}
</style>
